import { production, development } from "./strings";

export const serverlink = production.server;

export const GA = production.ga;
